module.exports = __webpack_public_path__ + "db96ae005a98d51133b7458f5b442ff7.png";